import React from 'react';
import Link from 'next/link';
import Tooltip from '@/sharedComponents/TextEditor/components/Tooltip';
import { css, Interpolation } from '@emotion/react';

type SidebarItemProps = {
  left?: any;
  center: any;
  right?: any;
  onClick?: () => void;
  onClickCenter?: () => void;
  link?: string;
  className?: string;
  selected?: boolean;
  containerClassname?: string;
  containerCSS?: Interpolation<any>;
  disabled?: boolean;
  tooltip?: string;
};

const sty = {
  container: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'var(--text, red)',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 500,
    padding: '6px 10px',
    // margin: '0px 5px',
  }),
  containerHoverable: css({
    '&:hover': {
      backgroundColor: 'var(--deprecated-neutral-100, red)',
    },
  }),
  containerSelected: css({
    backgroundColor: 'var(--deprecated-neutral-100, red)',
  }),
  containerDisabled: css({
    opacity: 0.5,
  }),
  center: css({
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '20px',
    color: 'var(--deprecated-neutral-700)',
    flexWrap: 'nowrap',
    paddingRight: '5px',
  }),
  left: css({
    marginRight: '8px',
    color: 'var(--text-light, red)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  right: css({}),
};

function SidebarItem({
  left,
  center,
  right,
  onClick,
  onClickCenter,
  link,
  className,
  selected,
  containerClassname,
  disabled,
  tooltip,
  containerCSS,
}: SidebarItemProps) {
  const component = link ? (
    <Link href={link} legacyBehavior>
      <div
        className={containerClassname}
        css={[
          sty.container,
          !disabled ? sty.containerHoverable : null,
          selected ? sty.containerSelected : null,
          disabled ? sty.containerDisabled : null,
          containerCSS,
        ]}
        data-testid="SidebarItem_container"
        onClick={onClick}
        role="none"
      >
        <div css={[left ? sty.left : null]}>{left}</div>
        <div
          css={[center ? sty.center : null]}
          className={className}
          role="none"
          onClick={onClickCenter}
        >
          {center}
        </div>
        <div css={[right ? sty.right : null]}>{right}</div>
      </div>
    </Link>
  ) : (
    <div
      role="none"
      data-testid="SidebarItem_container"
      className={containerClassname}
      css={[
        sty.container,
        !disabled ? sty.containerHoverable : null,
        selected ? sty.containerSelected : null,
        disabled ? sty.containerDisabled : null,
      ]}
      onClick={onClick}
    >
      <div css={[left ? sty.left : null]}>{left}</div>
      <div
        className={className}
        css={[center ? sty.center : null]}
        role="none"
        onClick={onClickCenter}
      >
        {center}
      </div>
      <div css={[right ? sty.right : null]}>{right}</div>
    </div>
  );
  return tooltip ? <Tooltip center={tooltip}>{component}</Tooltip> : component;
}

SidebarItem.defaultProps = {
  left: undefined,
  right: undefined,
  onClick: undefined,
  onClickCenter: undefined,
  link: undefined,
  className: undefined,
  selected: undefined,
  containerClassname: undefined,
  disabled: undefined,
};

export { SidebarItem };
